import { useContext, useEffect, useState } from "react";
import { APIContext } from "../../Contexts/APIContext";

export default function useData<T = any>(controller: string, action?: string, body?: any) {
    const { get, post, version } = useContext(APIContext);
    const [data, setData] = useState<T | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (version === -1) return;
        if (!controller || !action) return;

        const abortController = new AbortController();

        setLoading(true);

        const handleResponse = (res: T) => {
            if (!abortController.signal.aborted) setData(res);
            setLoading(false);
        };

        if (body) {
            post(controller, action, body, handleResponse, abortController.signal);
        } else {
            get(controller, action, handleResponse, abortController.signal);
        }

        return () => abortController.abort();
    }, [version, controller, action, body]);

    return { data, loading };
}
